import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { styled } from "@mui/material/styles";

const ColorButton = styled(Button)(({ theme }) => ({
  color: `${theme.palette.secondary.contrastText} !important`,
  backgroundColor: theme.palette.secondary.main,
  padding: "12px 10px",
  borderRadius: "20px",
  cursor: "pointer",
  display: "block",
  textAlign: "center",
  position: "relative",
  "&:hover": {
    backgroundColor: theme.palette.secondary.dark,
  },

  "&[disabled]": {
    opacity: 0.4,

    background: theme.palette.action.disabledBackground,

    color: theme.palette.text.disabled,

    "& .file": {
      cursor: "not-allowed",
    },
  },

  "& .file": {
    opacity: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    cursor: "pointer",
  },
}));

const ProductItem = () => {
  const theme = useTheme();
  const [formValues, setFormValues] = useState([
    {
      range: {},
      color: {},
      carcass: {},
      handle: {},
    },
  ]);

  const [uploadValue, setUploadValue] = useState([{ uploadFile: "" }]);

  let addFormFields = () => {
    setFormValues([
      ...formValues,
      { range: {}, color: {}, carcass: {}, handle: {} },
    ]);
  };

  let addUploadFields = () => {
    setUploadValue([...uploadValue, { uploadFile: "" }]);
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  let removeUploadFields = (i) => {
    let newUploadValue = [...uploadValue];
    newUploadValue.splice(i, 1);
    setUploadValue(newUploadValue);
  };

  return (
    <>
      <Container component="main" maxWidth="md" sx={{ py: 3 }}>
        <Box
          className="shadow"
          sx={{
            backgroundColor: theme.palette.background.paper,
            p: 2,
            position: "relative",
            borderRadius: "1.6rem",
            borderBottomRightRadius: 0,
            mb: 2.5,
          }}
        >
          {formValues.map((element, index) => (
            <>
              <Grid container xs={12} spacing={2} className={index ? 'mt-4 relative' : 'relative'}>
                <Grid item xs={3}>
                  <label className="pb-8 flex">Range</label>
                  <Select
                    required
                    // options={sortOptions}
                    styles={customStyles()}
                    className="w-full"
                  />
                </Grid>
                <Grid item xs={3}>
                  <label className="pb-8 flex">Color</label>
                  <Select
                    required
                    // options={sortOptions}
                    styles={customStyles()}
                    className="w-full"
                  />
                </Grid>
                <Grid item xs={3}>
                  <label className="pb-8 flex">Carcass</label>
                  <Select
                    required
                    // options={sortOptions}
                    styles={customStyles()}
                    className="w-full"
                  />
                </Grid>
                <Grid item xs={3}>
                  <label className="pb-8 flex">Handle</label>
                  <Select
                    required
                    // options={sortOptions}
                    styles={customStyles()}
                    className="w-full"
                  />
                </Grid>
                {index ? (
                  <IconButton
                    color="secondary"
                    onClick={() => removeFormFields(index)}
                    sx={{ position: 'absolute', right: '-30px', bottom: 4 }}
                  >
                    <FuseSvgIcon size={14}>heroicons-outline:x</FuseSvgIcon>
                  </IconButton>
                ) : null}
              </Grid>
            </>
          ))}
          <Button
            variant="contained"
            color="secondary"
            onClick={() => addFormFields()}
            size="small"
            sx={{
              position: "absolute",
              bottom: "-32px",
              right: 0,
              borderTopRightRadius: 0,
              borderTopLeftRadius: 0,
            }}
          >
            <FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>
          </Button>
        </Box>
        <Grid container xs={12} spacing={2} className="mb-16">
          <Grid item xs={4}>
            <label className="pb-8 block">Container No</label>
            <TextField
              required
              name="customer"
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={4}>
            <label className="pb-8 block">Loading Week</label>
            <Select
              required
              // options={sortOptions}
              styles={customStyles()}
              className="w-full"
            />
          </Grid>
          <Grid item xs={4}>
            <label className="pb-8 block">Freight</label>
            <Select
              required
              // options={sortOptions}
              styles={customStyles()}
              className="w-full"
            />
          </Grid>
        </Grid>

        <Grid container xs={12} className="mb-16">
          <label className="pb-8 block">Special Comments</label>
          <TextField
            placeholder="Write your comment here"
            multiline
            fullWidth
            rows={4}
          />
        </Grid>
        <Grid container xs={12} spacing={1} sx={{ position: "relative" }}>
          <Grid item xs={3}>
            <Card>
              <CardContent>
                <label className="pb-8 flex">DRW File</label>
                <ColorButton variant="contained" component="label">
                  <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                    heroicons-outline:upload
                  </FuseSvgIcon>{" "}
                  Upload
                  <input type="file" className="file" />
                </ColorButton>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={3}>
            <Card>
              <CardContent>
                <label className="pb-8 flex">Appliances Detail</label>
                <ColorButton variant="contained" component="label">
                  <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                    heroicons-outline:upload
                  </FuseSvgIcon>{" "}
                  Upload
                  <input type="file" className="file" />
                </ColorButton>
              </CardContent>
            </Card>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox />}
                label="Will be shared later"
                sx={{ "& span": { fontSize: "11px" } }}
              />
              <FormControlLabel
                control={<Checkbox />}
                label="NA"
                sx={{ "& span": { fontSize: "11px" } }}
              />
            </FormGroup>
          </Grid>
          <Grid item xs={3}>
            <Card>
              <CardContent>
                <label className="pb-8 flex">Order Checklist</label>
                <ColorButton variant="contained" component="label">
                  <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                    heroicons-outline:upload
                  </FuseSvgIcon>{" "}
                  Upload
                  <input type="file" className="file" />
                </ColorButton>
              </CardContent>
            </Card>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox />}
                label="DRW file supersedes"
                sx={{ "& span": { fontSize: "11px" } }}
              />
            </FormGroup>
          </Grid>
          {uploadValue.map((element, index) => (
            <>
              <Grid item xs={3}>
                <Card sx={{ position: "relative" }}>
                  <CardContent>
                    <label className="pb-8 flex">Drawing File</label>
                    <ColorButton variant="contained" component="label">
                      <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                        heroicons-outline:upload
                      </FuseSvgIcon>{" "}
                      Upload
                      <input type="file" className="file" />
                    </ColorButton>
                  </CardContent>
                  {index ? (
                    <IconButton
                      onClick={() => removeUploadFields(index)}
                      size="small"
                      sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                      }}
                    >
                      <FuseSvgIcon size={18}>heroicons-outline:x</FuseSvgIcon>
                    </IconButton>
                  ) : null}
                </Card>
              </Grid>
            </>
          ))}
          <IconButton
            variant="contained"
            color="primary"
            onClick={() => addUploadFields()}
            size="small"
            sx={{
              marginRight: '-34px',
              height: '34px',
              top: '45px',
            }}
          >
            <FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>
          </IconButton>
        </Grid>
      </Container>
    </>
  );
};

export default ProductItem;
